import Api from "../../api.js";

export const create = async (url, data, config) => {
    return (await Api.post(url, data, config))?.data
}
